/* @flow */

import {formEncodedApi} from 'nutshell-core/api';

const MAX_SERVER_RESULTS = 25;

function getDescription(entityName: ?string): string {
    switch (entityName) {
        case 'Users':
            return 'Nutshell User';
        case 'Accounts':
            return 'Company';
        case 'Leads':
            return 'Lead';
        case 'Teams':
            return 'Team';
        case 'Contacts':
        default:
            return 'Person';
    }
}

function getType(entityName: ?string): string {
    return entityName ? entityName.toLowerCase() : '';
}

function getId(entityId: string, entityName: string) {
    return `${entityId}-${getType(entityName)}`;
}

function mapEntityToReturn(entity: any): Object {
    return {
        id: getId(entity.entityId, entity.entityName),
        value: entity.name,
        type: getType(entity.entityName),
        avatarUrl: entity.avatarUrl,
        initials: entity.initials,
        emailAddress: entity.emailAddress,
        description: getDescription(entity.entityName),
    };
}

export function getEntities(query: string): Promise<Object> {
    const data = {
        rows: MAX_SERVER_RESULTS,
        fields: [
            {
                name: 'name',
                value: query,
            },
        ],
    };

    return formEncodedApi
        .post('/solr/find-mentionable-entities.json', {
            ...data,
        })
        .then((response) => response.json())
        .then((response: {results: any[]}) => {
            const results: any[] = response.results ? response.results : [];

            return results
                .map((entity) => {
                    return mapEntityToReturn(entity);
                })
                .filter((entity) => entity.value);
        });
}
